import ArrowIcon from "./arrow-icon";
import UsersIcon from "./users-icon";
import EventsIcon from "./events-icon";
import LastMinIcon from "./last-min-icon";
import LogOutIcon from "./log-out-icon";
import ProfileIcon from "./profile-icon";
import SubContractorsIcon from "./subcontractors-icon";
import EditIcon from "./edit-icon";
import LogsIcon from "./logs-icon";
import SendPassIcon from "./send-pass-icon";
import DeleteIcon from "./delete-icon";
import ChangePassIcon from "./change-pass-icon";
import FilterIcon from "./filter-icon";
import DownloadIcon from "./download-icon";
import ImportIcon from "./import-icon";
import UpdateIcon from "./update-icon";
import KeyIcon from "./key-icon";
import CraftsIcon from "./crafts-icon";
import AttentionIcon from "./attention-icon";
import GearIcon from "./gear-icon";
import InProcesIcon from "./in-proces-icon";
import NoJobsIcon from "./no-jobs-icon";
import PadlockIcon from "./padlock-icon";
import DocumentIcon from "./document-icon";
import QrCodeIcon from "./qr-code-icon";
import PrinterIcon from "./printer-icon";
import CheckBoxIcon from "./checkbox-icon";
import DeliveryTruckIcon from "./truck-icon";
import TruckReverseIcon from "./truck-reverse-icon";
import TruckReverseWayIcon from "./truck-reverse-way-icon";
import TruckArrowIcon from "./truck-arrow-icon";
import ShelfIcon from "./shelf-icon";
import AdditionalCraftIcons from "./crafts-additional-icon";
import AttachmentIcon from "./attachment-icon";
import CommentsIllustrationIcon from "./comments-illustration-icon";
import StaffManagementIcon from "./staff-management-icon";
import StaffQrCodeIcon from "./staff-qr-code-icon";
import StaffCalendarIcon from "./staff-calendar-icon";
import StaffPrinterIcon from "./staff-printer-icon";
import StaffNoQrCodeIllustration from "./staff-no-qr-code-illustration";
import StaffInProcessIcon from "./staff-in-process-icon";
import StaffClockIcon from "./staff-clock-icon";
import StaffAttentionIcon from "./staff-attention-icon";
import StaffLocationMapIcon from "./staff-location-map-icon";
import StaffInfoIcon from "./staff-info-icon";
import StaffCheckInIcon from "./staff-check-in-icon";
import StaffCheckOutIcon from "./staff-check-out-icon";
import StaffInvalidQrIcon from "./staff-invalid-qr-icon";
import StaffSameDeviceIcon from "./staff-same-device-icon";
import StaffLocationFailedIcon from "./staff-location-failed-icon";
import StaffCameraAccessIcon from "./staff-camera-access-icon";
import StaffLocationIcon from "./staff-location-icon";
import HuaweiIcon from "./huawei-icon";




const Icons = {
    Arrow: ArrowIcon,
    Users: UsersIcon,
    Events: EventsIcon,
    LastMin: LastMinIcon,
    LogOut: LogOutIcon,
    Profile: ProfileIcon,
    SubContractors: SubContractorsIcon,
    Edit: EditIcon,
    Logs: LogsIcon,
    SendPass: SendPassIcon,
    Delete: DeleteIcon,
    ChangePass: ChangePassIcon,
    Filter: FilterIcon,
    Download: DownloadIcon,
    Import: ImportIcon,
    Update: UpdateIcon,
    Key: KeyIcon,
    Crafts: CraftsIcon,
    AdditionalCrafts: AdditionalCraftIcons,
    Attention: AttentionIcon,
    Gear: GearIcon,
    InProces: InProcesIcon,
    NoJobs: NoJobsIcon,
    Padlock: PadlockIcon,
    Document: DocumentIcon,
    QrCode: QrCodeIcon,
    Printer: PrinterIcon,
    CheckBox: CheckBoxIcon,
    DeliveryTruck: DeliveryTruckIcon,
    TruckReverse: TruckReverseIcon,
    TruckReverseWay: TruckReverseWayIcon,
    TruckArrow: TruckArrowIcon,
    Shelf: ShelfIcon,
    Attachment: AttachmentIcon,
    CommentsIllustration: CommentsIllustrationIcon,
    StaffManagement: StaffManagementIcon,
    StaffQrCode: StaffQrCodeIcon,
    StaffCalendar: StaffCalendarIcon,
    StaffPrinter: StaffPrinterIcon,
    StaffNoQrCode: StaffNoQrCodeIllustration,
    StaffInProcess: StaffInProcessIcon,
    StaffClock: StaffClockIcon,
    StaffAttention: StaffAttentionIcon,
    StaffLocationMap: StaffLocationMapIcon,
    StaffInfo: StaffInfoIcon,
    StaffCheckIn: StaffCheckInIcon,
    StaffCheckOut: StaffCheckOutIcon,
    StaffInvalidQr: StaffInvalidQrIcon,
    StaffSameDevice: StaffSameDeviceIcon,
    StaffLocationFailed: StaffLocationFailedIcon,
    StaffCameraAccess: StaffCameraAccessIcon,
    StaffLocation: StaffLocationIcon,
    Huawei: HuaweiIcon,
}

export default Icons;
